import React from "react";

const ChartCard = ({ title, subtitle, children, loading }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
    <div className="mb-2">
      <h2
        className="text-lg font-extrabold"
        style={{ color: "#000", fontWeight: 800 }}
      >
        {title}
      </h2>
      {subtitle && (
        <p className="text-sm mt-1" style={{ color: "#000", fontWeight: 700 }}>
          {subtitle}
        </p>
      )}
    </div>
    {children}
  </div>
);

export default ChartCard;
